export const LOGO = 'logo';
export const TEXT = 'text';
export const LOGO_WITH_TEXT = 'logo_with_text';
